module.exports = __webpack_public_path__ + "static/media/david-troeger-9-xzy-ez-pahmi-unsplash-copy.73bee394.jpg";